module.exports = __webpack_public_path__ + "img/brush.6a23aa4c.svg";